import Main from './Main.vue'
import Lista from './components/ListaTransferencias'
import Transferencia from './components/Transferencia'

export default [{
  path: 'transferencia-patio',
  name: 'transferencia-patio',
  component: Main,
  children: [
    {path: '/', component: Lista, name: 'transferencia-patio'},
    {path: 'registrar', component: Transferencia, name: 'transferencia-patio.novo'},
    {path: ':id', component: Transferencia, name: 'transferencia-patio.visualizar'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/transferencia-patio/routes.js